// 站点导航菜单状态
﻿import { getPortalMenus } from '@/api/portal'
import { findMenuByPath, HOME_PATH, mergeProductNavChildren, transformPortalMenus } from '@/components/layout/utils/navMenu'
import { isPortalMenuVisible } from '@/components/portal/common/utils/portalMenuVisibility'

let menuFetchSeq = 0
let inflightMenuFetch = null

export default {
  namespaced: true,
  state: {
    menus: [],
    rawMenus: [],
    menusLocale: '',
    activeKey: '',
    loading: false,
    loaded: false,
    menuVersion: 0
  },
  getters: {
    navMenus(state, getters, rootState, rootGetters) {
      const categories = rootGetters['productCategories/enabledItems'] || []
      const headerMenus = state.menus.filter((item) => isPortalMenuVisible(item, state.menusLocale))
      return mergeProductNavChildren(headerMenus, categories)
    },
    sidebarMenu(state) {
      if (!state.activeKey) return null
      return state.menus.find((menu) => menu.key === state.activeKey) || null
    },
    homeMenu(state) {
      return state.menus.find((menu) => menu.isHome) || null
    }
  },
  mutations: {
    SET_MENUS(state, { menus, rawMenus, locale }) {
      state.menus = menus
      state.rawMenus = rawMenus || []
      state.menusLocale = locale || ''
      state.loaded = true
      state.menuVersion += 1
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ACTIVE(state, key) {
      state.activeKey = key
    },
    RESET(state) {
      state.menus = []
      state.rawMenus = []
      state.menusLocale = ''
      state.loaded = false
    },
    TOGGLE_ACTIVE(state, key) {
      state.activeKey = state.activeKey === key ? '' : key
    },
    SYNC_ROUTE(state, path) {
      const menu = findMenuByPath(state.menus, path)
      if (menu) {
        state.activeKey = menu.key
        return
      }
      state.activeKey = path === HOME_PATH ? '' : state.activeKey
    }
  },
  actions: {
    async reloadMenus({ commit, dispatch }) {
      menuFetchSeq += 1
      inflightMenuFetch = null
      commit('RESET')
      await Promise.all([
        dispatch('fetchMenus', { force: true }),
        dispatch('productCategories/reloadCategories', null, { root: true })
      ])
    },
    async ensureRawMenus({ dispatch, state, rootState }) {
      const locale = rootState.locale.current
      if (!locale) return []

      if (state.loaded && state.menusLocale === locale && state.rawMenus.length) {
        return state.rawMenus
      }

      await dispatch('fetchMenus')
      return state.rawMenus
    },
    async fetchMenus({ commit, state, rootState }, options) {
      const { force = false } = options ?? {}
      const locale = rootState.locale.current
      if (!locale) return

      if (!force && state.loaded && state.menusLocale === locale) return

      if (force) {
        menuFetchSeq += 1
        inflightMenuFetch = null
      }

      if (inflightMenuFetch?.locale === locale && !force) {
        return inflightMenuFetch.promise
      }

      const seq = ++menuFetchSeq
      commit('SET_LOADING', true)

      // promise
      const promise = (async () => {
        try {
          const data = await getPortalMenus(locale, { reload: force })
          if (seq !== menuFetchSeq) return
          commit('SET_MENUS', {
            menus: transformPortalMenus(data, locale),
            rawMenus: data || [],
            locale
          })
        } catch (error) {
          if (seq !== menuFetchSeq) return
          commit('SET_MENUS', { menus: [], rawMenus: [], locale })
          throw error
        } finally {
          if (seq === menuFetchSeq) {
            commit('SET_LOADING', false)
          }
        }
      })()

      inflightMenuFetch = { locale, promise }
      try {
        await promise
      } finally {
        if (inflightMenuFetch?.promise === promise) {
          inflightMenuFetch = null
        }
      }
    }
  }
}
